import React, { useState } from "react";
import AddButton from "@core/buttons/atoms/AddButton";
import AddModal from "@core/modals/AddModal";
import Input from "@core/inputs/Input";
import { showError, showSuccess } from "@utils/helpers";
import { useTranslation } from "react-i18next";
import SubStrataService from "@services/SubStrataService";
import PermissionHandler from "@hoc/cruds/PermissionHandler";
import StrataSelect from "@components/Strata/partials/StrataSelect";

const CreateSubStrata = ({ onAdded }) => {
  const { t } = useTranslation();
  const [showModal, setShowModal] = useState(false);
  const [loading, setLoading] = useState(false);
  const [name, setName] = useState("");
  const [englishName, setEnglishName] = useState("");
  const [description, setDescription] = useState("");
  const [selectedStratum, setSelectedStratum] = useState();

  const closeModal = () => {
    setShowModal(false);
    setName("");
    setEnglishName("");
    setDescription("");
    setSelectedStratum();
  };

  const onSubmit = (event) => {
    event.preventDefault();
    setLoading(true);
    SubStrataService.create(name, englishName, selectedStratum, description)
      .then(() => {
        showSuccess(t("subStrataCreatedSuccessfully"));
        closeModal();
        onAdded();
      })
      .catch((err) => {
        showError(err.response.data.message);
      })
      .finally(() => {
        setLoading(false);
      });
  };

  return (
    <PermissionHandler permission={"create_sub_stratum"}>
      <AddButton label={t("addSubStrata")} onClick={() => setShowModal(true)} />
      <AddModal
        show={showModal}
        title={t("addSubStrata")}
        onClose={closeModal}
        onSubmit={onSubmit}
        loading={loading}
      >
        <div className="mt-4 sm:mt-8 mb-2 grid grid-cols-2 gap-5 sm:gap-10">
          <Input
            height="h-10"
            label={t("name")}
            placeholder={t("name")}
            value={name}
            onChange={setName}
          />
          <Input
            height="h-10"
            label={t("nameEng")}
            placeholder={t("nameEng")}
            value={englishName}
            onChange={setEnglishName}
          />
          <Input
            height="h-10"
            label={t("description")}
            placeholder={t("description")}
            value={description}
            onChange={setDescription}
          />
          <div>
            <div>
              <div className="text-sm font-semibold mb-2">{t("strata")}</div>
              <StrataSelect
                openModal={showModal}
                selected={selectedStratum}
                onSelect={setSelectedStratum}
              />
            </div>
          </div>
        </div>
      </AddModal>
    </PermissionHandler>
  );
};

export default CreateSubStrata;
